import styled from 'styled-components'
import { Link as RouterLink } from 'react-router-dom'
import type { FunctionComponent } from 'react'
import Link from '../Link/Link'

interface LocationDescriptorObject {
  pathname?: string | undefined
  search?: string | undefined
}

const StyledLink = styled(Link)`
  color: var(--blue);
  cursor: pointer;
  svg,
  span svg {
    fill: var(--blue);
  }
`

export interface SearchLinkProps {
  to: LocationDescriptorObject
  label: string
  title?: string
}

const SearchLink: FunctionComponent<SearchLinkProps> = ({ to, label, title = '' }) => (
  <StyledLink
    data-testid="searchLink"
    inList
    forwardedAs={RouterLink}
    to={to}
    title={title || label}
  >
    {label}
  </StyledLink>
)

export default SearchLink
